import { ChantContext } from '../../gregorio-chant/ChantContext';
import { ChantSyllableElement } from '../containers/ChantSyllableElement';
import { VisualizerHelper } from './VisualizerHelper';
import { GregorioGlyph } from '../../gregorio-chant/structures/GregorioGlyph';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { Line } from '../../drawing';
import { calculateHeightPositionFromPitch } from '../utils';
import { isBarVisualizer } from './helpers';
import { PunctaInclinata } from '../enums/constants';
import { GlyphVisualizer } from './GlyphVisualizer';
import { GregorioNoteElement } from '../../gregorio-chant/structures/GregorioNoteElement';

// vertical episema
export class Ictus extends ChantLayoutElement {
  private readonly _lines: Line[] = [];
  private readonly _glyph?: GregorioGlyph;
  private readonly _height = this._context.pitchHeight * 0.55;

  constructor(context: ChantContext, glyph?: GregorioGlyph) {
    super(context);
    this._glyph = glyph;
  }

  getY(note: GregorioNoteElement) {
    if (note.v_episema_height % 2 === 1 || note.v_episema_height < 5) {
      return calculateHeightPositionFromPitch(this._context, note.v_episema_height);
    } else {
      return calculateHeightPositionFromPitch(this._context, note.v_episema_height) + this._context.pitchHeight / 4;
    }
  }

  performLayout(noteElements: ChantSyllableElement[]) {
    const noteElement = VisualizerHelper.findLastGlyphOrBar(noteElements);

    if (noteElement === undefined) {
      return;
    }

    if (isBarVisualizer(noteElement)) {
      const line = Line.createVerticalLine(noteElement.bounds.x + noteElement.bounds.width / 2, 54, 6);
      this._lines.push(line);
    }

    if (this._glyph) {
      if (PunctaInclinata.includes(this._glyph.notes.glyph_type)) {
        const visualizers = noteElements.filter((v) => v instanceof GlyphVisualizer);
        const notes = this._glyph.notes.notes;
        for (let i = 0; i < notes.length; ++i) {
          const note = notes[i];
          if (note.v_episema_height) {
            const noteElement = visualizers[visualizers.length - notes.length + i];
            if (noteElement) {
              const line = Line.createVerticalLine(noteElement.bounds.x + noteElement.bounds.width / 2,
                this.getY(note), this._height);
              this._lines.push(line);
            }
          }
        }
      } else {
        const notes = this._glyph.notes.notes;
        const noteWidth = this._context.pitchWidth;
        const estimatedWidth = noteWidth * notes.length - 2;
        if (estimatedWidth > noteElement.bounds.width) {
          for (let i = 0; i < notes.length; ++i) {
            const note = notes[i];
            if (note.v_episema_height) {
              const line = Line.createVerticalLine(noteElement.bounds.x + noteElement.bounds.width / 2,
                this.getY(note), this._height);
              this._lines.push(line);
            }
          }
        } else {
          for (let i = 0; i < notes.length; ++i) {
            const note = notes[i];
            if (note.v_episema_height) {
              const line = Line.createVerticalLine(noteElement.bounds.x + noteWidth * i + noteWidth / 2,
                this.getY(note), this._height);
              this._lines.push(line);
            }
          }
        }
      }
    }
  }

  public createSvgFragments(): SVGElement[] {
    const elements: SVGElement[] = [];
    for (const line of this._lines) {
      const el = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      el.setAttribute('x1', String(line.start.x));
      el.setAttribute('y1', String(line.start.y));
      el.setAttribute('x2', String(line.end.x));
      el.setAttribute('y2', String(line.end.y));

      el.setAttribute('stroke', '#000000');
      el.setAttribute('stroke-width', '1.5');

      elements.push(el);
    }

    return [
      ...super.createSvgFragments(),
      ...elements,
    ];
  }
}
